export default __webpack_public_path__ + "static/media/two.73303d19.jpeg";